import request from '@/utils/request'

// GET /api/base/qrySoftVersion 查询软件版本
export function qrySoftVersion(params) {
  return request({
    url: '/api/base/qrySoftVersion',
    method: 'GET',
    params
  })
}
// POST /api/base/addSoftVersion 添加软件版本
export function addSoftVersion(data) {
  return request({
    url: '/api/base/addSoftVersion',
    method: 'POST',
    data
  })
}
// POST /api/base/delSoftVersion 删除软件版本
export function delSoftVersion(data) {
  return request({
    url: '/api/base/delSoftVersion',
    method: 'POST',
    data
  })
}

// GET /api/base/qrySoftVersionAcross 查询横屏软件版本横屏
export function qrySoftVersionAcross(params) {
  return request({
    url: '/api/base/qrySoftVersionAcross',
    method: 'GET',
    params
  })
}
// POST /api/base/addSoftVersionAcross 添加横屏软件版本
export function addSoftVersionAcross(data) {
  return request({
    url: '/api/base/addSoftVersionAcross',
    method: 'POST',
    data
  })
}
// POST /api/base/delSoftVersionAcross 删除横屏软件版本
export function delSoftVersionAcross(data) {
  return request({
    url: '/api/base/delSoftVersionAcross',
    method: 'POST',
    data
  })
}
